module.exports = __webpack_public_path__ + "img/galactica_blueprints_15.f44c69a7.png";